export const PANEL_QUERY_KEY = 'panel';

export const PUBLIC_PANELS = {
  LOGIN: 'connexion',
  SIGNUP: 'inscription',
  FORGOT_PASSWORD: 'mot-de-passe-oublie',
};

export const PUBLIC_PANEL_VALUES: string[] = Object.values(PUBLIC_PANELS);
